import { defineStore } from 'pinia';
import eventsApi from '@/api/eventsApi.js';

export const useEventsStore = defineStore('eventsStore', {
    state: () => ({
        // Хранилище событий по ключу "target:id"
        eventsByEntity: {},
    }),

    getters: {
        /**
         * Получить события для конкретной сущности
         * @param {string} target - Тип сущности
         * @param {number|string} id - ID сущности
         * @returns {{count: number, next: string|null, previous: string|null, results: Array, page: number}}
         */
        getEvents: (state) => (target, id) => {
            const key = `${target}:${id}`;
            return state.eventsByEntity[key] || {
                count: 0,
                next: null,
                previous: null,
                results: [],
                page: 1,
            };
        },
    },

    actions: {
        /**
         * Загрузить события для сущности
         * @param {string} target - Тип сущности: 'work' | 'facility' | 'customer' | 'contract' | 'user'
         * @param {number|string} id - ID сущности
         * @param {number} page - Номер страницы
         * @param {object} filters - Фильтры (verb и др.)
         */
        async loadEvents(target, id, page = 1, filters = {}) {
            const key = `${target}:${id}`;

            try {
                const data = await eventsApi.getEvents(target, id, { page, ...filters });

                this.eventsByEntity[key] = {
                    count: data?.count ?? 0,
                    next: data?.next ?? null,
                    previous: data?.previous ?? null,
                    results: Array.isArray(data?.results) ? data.results : [],
                    page,
                };
            } catch (error) {
                console.error(`Ошибка загрузки событий для ${target}:${id}:`, error);

                // Устанавливаем пустое состояние при ошибке
                this.eventsByEntity[key] = {
                    count: 0,
                    next: null,
                    previous: null,
                    results: [],
                    page: 1,
                };
            }
        },

        /**
         * Очистить события для сущности
         * @param {string} target - Тип сущности
         * @param {number|string} id - ID сущности
         */
        clearEvents(target, id) {
            const key = `${target}:${id}`;
            delete this.eventsByEntity[key];
        },

        /**
         * Очистить все события
         */
        clearAllEvents() {
            this.eventsByEntity = {};
        },
    },
});
